export const CUSTOMER_POOL_INIT_DATA = "customer pool init data" //第一次初始化数据
//页数发生改变时,无数据情况
export const CUSTOMER_POOL_PAGINATION_INFO = "customer pool pagination info"
//页数发生改变时,有数据情况
export const CUSTOMER_POOL_PAGINATION_INFO_HAVE = "customer pool pagination info have"
//输入框内容发生变化
export const CUSTOMER_POOL_INPUT_BOX = "customer pool input box"

//请求参数发生改变，列表数据重新请求
export const CUSTOMER_POOL_PARAM_CAHNGES_INQUIRE = "customer pool param changes inquire"
//页数重置
export const CUSTOMER_POOL_RESET_PAGE = "customer pool reset page"

//重置请求参数
export const CUSTOMER_POOL_RESET_REQUEST_PARAM = "customer pool requset param"

//重新请求页数数据，列表数据重置
export const CUSTOMER_POOL_ANEW_REQUSET_DATA = "customer pool anew requset data"



// WEBPACK FOOTER //
// ./src/vuex/custPool/type.js